import { render } from "./HeaderVehicleSummary.vue?vue&type=template&id=1867746c"
import script from "./HeaderVehicleSummary.vue?vue&type=script&lang=js"
export * from "./HeaderVehicleSummary.vue?vue&type=script&lang=js"
script.render = render

export default script